/**
 * Semver passed to `deprecate({ until })` for SPDS-owned deprecations when removal is not
 * tied to a specific ember-source release. Ember’s debug `deprecate` requires a truthy
 * `until` value; a far-future version satisfies that without implying a real removal target.
 */
export const SPDS_DEPRECATION_UNTIL_VERSION = '99.0.0';

export default { SPDS_DEPRECATION_UNTIL_VERSION };
